<template>
  <div>
    <bread-crumb :categorialeilao="leilao.categorialeilao"></bread-crumb>
    <Stretch v-show="loadingPage">Carregando...</Stretch><!-- LOADING -->
    <div v-if="naoEncomtrado"><!-- MENSAGEM DE NÃO ENCONTRADO -->
      <nao-encontrado :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado>
    </div>
    <div v-show="loadingPage == false && naoEncomtrado == false"><!-- CATEGORIA -->

      <filtro :leilao="leilao" :filtros="filtros" :iscategoria="true" v-show="filtros != false"></filtro>        
      <Stretch v-show="loadingRefresh">Carregando...</Stretch>
      <div class="pag-container-vu paginatio-mobile" style="clear:both;" v-show="firstLoadCategoria == false && loadingRefresh == false">
          <paginate
          :page-count="Number(paginator.pageCount)"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'Anterior'"
          :next-text="'Próximo'"
          :container-class="'pagination'"
          :force-page="paginaAtual"
          :page-class="'page-item'"
          ref="paginate1">
          </paginate>
          <div class="clearfix"></div>
      </div>
      <div id="target_scroll"></div>
      <div v-for="(leilao,idx) in lotesAgrupados" :key="idx" class="grupo-leilao">
          <header-disputa :leilaoid="leilao.leilao_id" :lotes="leilao.lotes"></header-disputa>
          <ul  :id="'grid-'+leilao.leilao_id" class="products-grid columns4" v-show="firstLoadCategoria == false && loadingRefresh == false">
              <li v-for="(lote, idx2) in leilao.lotes" :key="idx2" class="lote-item">
                  <card  :leilao="leilao" :dados="lote" :liberado="leilao.liberado" :automatico="leilao.fechamento" :usuarioid="usuario.id"></card>
              </li>
          </ul>
      </div>
    </div>
    <div class="pag-container-vu" v-show="firstLoadCategoria == false && loadingRefresh == false">
      <paginate
        :page-count="Number(paginator.pageCount)"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'Anterior'"
        :next-text="'Próximo'"
        :container-class="'pagination'"
        :force-page="paginaAtual"
        :page-class="'page-item'"
        ref="paginate2">
      </paginate>
    </div>
</div>
</template>
<script>
import Card from '@/components/shared/Card'
import Paginate from 'vuejs-paginate'
import {Stretch} from 'vue-loading-spinner'
import { Carousel, Slide } from 'vue-carousel'

//LAYOUT COMPONENT
import BreadCrumb from '@/components/shared/BreadCrumb'
import BotoesRotas from '@/components/shared/BotoesRotas'
import NaoEncontrado from '@/components/shared/NaoEncontrado'
import HeaderDisputa from '@/components/shared/HeaderDisputa'
import MensagemBox from '@/components/shared/MensagemBox'
import Filtro from '@/components/shared/Filtro'

export default {
name: 'SalaDisputa',
components:{
  BreadCrumb,
  Card,
  Stretch,
  Paginate,
  Carousel,
  Slide,
  BotoesRotas,
  NaoEncontrado,
  HeaderDisputa,
  MensagemBox,
  Filtro
},
data () {
  return {
    leilao: { },
    lotes: [],
    lotesFiltrados: [],
    lotesPregao: [],
    config_leiloeiro: [],
    dados_condicao: [],
    usuario: [],
    paginator: [],
    filtros: [],
    errors: [],
    lotesAgrupados: [],
    dadosRequisicao: {},
    value_video: null,
    loadingPage: true,
    loadingRefresh: false,
    naoEncomtrado: false,
    firstLoadCategoria: true,
    paginaAtual: 1,
    parametrosFiltro: '',
    montagem: '',
    statusLeilao: '',
    statusLeilaoBg: '',
    montagembg: '',
    refreshSalaDisputa:null,
    refreshCountCategoria: 30000,
    cookie: true,
    saladisputa: null,
    lotesStatusReference: [],
    lotesLanceReference: [],
    lotesIncrementoReference: [],
    lotesDtfechamentoReference: []
  }
},
methods:{
  callData (pageNumber,FiltroLoad) { // REQUEST DOS DADOS LISTAGEM - SALA DE DISPUTA
    const hostName = location.protocol + "//" + window.HOSTNAME
    const pageNum =   pageNumber ? `?page=${pageNumber}` : ''
    const FiltroL = pageNum ? `&${FiltroLoad}` : `?${FiltroLoad}`
    const changeFiltro = FiltroLoad ? FiltroL : ''
    const self = this

      if (pageNumber) {
          this.paginaAtual = pageNumber
      }
    self.lotesAgrupados = []
    
    var qry_comitente = '';
    if (this.$route.query.comitente_id) {
      qry_comitente = '/comitente_id/' + this.$route.query.comitente_id;
    }

    var qry_statuscomitente = '';
    if (this.$route.query.statuscomitente_id) {
      qry_comitente = '/statuscomitente_id/' + this.$route.query.statuscomitente_id;
    }

    self.axios.get(`${hostName}/index/${self.$route.params.categoria}/firebase/1${qry_comitente}${qry_statuscomitente}${pageNum}${changeFiltro}`)
    .then((response) => {
        if(Object.keys(response.data.lotes).length <= 0){
            self.loadingPage = false
            self.naoEncomtrado = true
            return false
        }
        
        var lotes_format = Object.values(response.data.lotes);

        lotes_format = lotes_format.sort(function(a, b) {
            var x = a['nu_ordem_lote']; var y = b['nu_ordem_lote'];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
        
        self.lotes = lotes_format
        self.lotesFiltrados = lotes_format
        self.usuario = response.data.usuario

        // observa lotes firebase
        this.saladisputa.observaLotesStatusLance(self.lotesFiltrados)

        self.leilao.categorialeilao = [
            {"id":200,"leilao_id":29,"categorialeilao_id":1,"nm_categoria":"Veículos"},
            {"id":201,"leilao_id":29,"categorialeilao_id":2,"nm_categoria":"Equipamentos"},
            {"id":202,"leilao_id":29,"categorialeilao_id":3,"nm_categoria":"Imóveis"},
            {"id":203,"leilao_id":29,"categorialeilao_id":5,"nm_categoria":"Semoventes"}
        ]
        self.paginator = response.data.paginator
        self.filtros = response.data.filtros
        
          //GERANDO GRUPO DE CATEGORIA POR LEILAO
          if(self.firstLoadCategoria || self.loadingRefresh){
            let groups = {};
            for(let prop in self.lotesFiltrados) {
                let leilaoId = self.lotesFiltrados[prop].leilao_id
                if (!groups[leilaoId]) {
                    groups[leilaoId] = []
                }
                groups[leilaoId].push(self.lotesFiltrados[prop])
            }
            self.lotesAgrupados = []
            for (var leilaoId in groups) {
                self.lotesAgrupados.push({leilao_id: leilaoId,liberado: false, fechamento:false, lotes: groups[leilaoId]})

            }
          }
          
          self.saladisputa.refreshLotesAgrupados(self.lotesFiltrados)

          self.lotesAgrupados.map((item,i) => {
              self.axios.get(`${hostName}/leilao/get-leilao?leilao_id=${item.leilao_id}`).then((res) => {
                  self.lotesAgrupados.leilao = res.data.leilao
                  self.lotesAgrupados.dados_condicao = res.data.dados_condicao
                  self.lotesAgrupados.usuario = res.data.usuario
                  self.lotesAgrupados.config_leiloeiro = res.data.config_leiloeiro

                  self.loadingPage = false
                  self.loadingRefresh = false

                  self.lotesAgrupados.map((item2,i2) => {
                    if(res.data.dados_condicao.aceitou_condicao == true && res.data.usuario.id !== null){
                      if(res.data.usuario.statusliberacaoonline_id == 3 || res.data.usuario.statusliberacaoonline_id == '3'){
                        self.lotesAgrupados[i2].liberado = true
                      }
                    }
                    self.lotesAgrupados[i2].fechamento = res.data.leilao.bn_fechamentoautomatico
                  })
                  

              }).catch(e => {
                  this.errors.push(e)
              })
          })

        /* CONFIG AUTO RELOAD */
        /* manter refresh padrao (30s) */
        /*if(self.usuario.id !== null){
          if(self.usuario.statusliberacaoonline_id !== 3){
            self.refreshCountCategoria = 10000
          }else{
            if(self.leilao.bn_fechamentoautomatico == true){
              self.refreshCountCategoria = 1000
            }else{
              self.refreshCountCategoria = 4000
            }
          }
        }*/

        if(self.refreshCountCategoria && self.firstLoadCategoria){

          const filtro2 = document.querySelector('#filtro2')
          filtro2.addEventListener('change',function(){
            if(filtro2.value == ''){
              document.querySelector('#filtro3').value = ''
              document.querySelector('#filtro4').disabled = true
              document.querySelector('#filtro4').value = ''
            }
          })

          //window.INTERVALO_CATEGORIA = setInterval(() => {
///              self.callData(self.paginaAtual,self.parametrosFiltro)
          //},self.refreshCountCategoria)
        }

        self.firstLoadCategoria = false

        document.getElementById('filtro2').disabled = false
    })
    .catch(e => {
      this.naoEncomtrado = true
      this.loadingPage = false
      this.errors.push(e)
    })

  },
  refreshFirebase()
  {
    this.saladisputa.refreshLotesAgrupados(this.lotesFiltrados)
  },
  clickCallback (pageNum) { // ATUALIZA O NÚMERO DA PÁGINA ATUAL PARA AMBOS (PAGINACAO)
    this.loadingRefresh = true
    this.callData(pageNum)
    this.$refs.paginate1.selected = this.$refs.paginate2.selected = pageNum - 1;
  }
},
created () { // INIT
  this.loadingPage = true

  clearInterval(window.INTERVALO_BUSCA)
  clearInterval(window.INTERVALO_CATEGORIA)

  this.saladisputa = new window.saladisputa(this)
  this.callData()

  this.$on('filtroChange', function (dadosFiltro) {
    let parametros = ''
    if(dadosFiltro.filtro1 !== ''){  parametros += `segmento_id=${dadosFiltro.filtro1}` }
    else{ parametros = '' }

    if(dadosFiltro.filtro2 !== ''){  parametros += `&filtro1=${dadosFiltro.filtro2}` }
    if(dadosFiltro.filtro3 !== ''){  parametros += `&filtro2=${dadosFiltro.filtro3}` }
    this.parametrosFiltro = parametros  

    this.loadingRefresh = true
    this.callData(this.paginaAtual,parametros)
  })
  const self = this
  this.$on('liberacaoMensagem',function(json){
    self.lotesAgrupados.map((item,i) => {
      if(Number(self.lotesAgrupados[i].leilao_id) == Number(json.leilaoId)){
        self.lotesAgrupados[i].liberado = json.liberado
        self.lotesAgrupados[i].fechamento = json.fechamento
      }
    })
  })

  //verifica cookie e browser
  this.cookie = this.$root.cookieAtivo
  this.$root.MensagemBrowserCookie()
}
}
</script>
<style>
.doc-icons{
  cursor:pointer;
  text-align:center;
}
.dialog-content {
    max-height: 400px;
    overflow: auto;
}
.boxRegulamento {
  padding: 0px !important;
}
.container-box {
    height: auto !important;
    width: 100% !important;
    overflow: inherit !important;
}
#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom:200px;
}
#portotemplate .spinner div{ background-color: #67302b !important; }
#portotemplate a:hover, #portotemplate a:focus {
    text-decoration: none;
}
.VueCarousel-navigation a.VueCarousel-navigation-prev{ 
  left:24px !important; 
  background: #fff;
  border-radius: 2px;
}
.VueCarousel-navigation a.VueCarousel-navigation-next{ 
  right:24px !important; 
      border-radius: 2px;
      background: #fff;
}
.VueCarousel-navigation a.VueCarousel-navigation--disabled{ display:none; }
.pag-container-vu {
  width:98%;
  margin:20px auto;
  text-align: center;
 }
#portotemplate .pagination > li:first-child > a, #portotemplate .pagination > li:last-child > a, #portotemplate .pagination > li:last-child > span {
  padding: 2px 5px;
}
#portotemplate .li-hidden{ display:none; }
@media(max-width: 600px){
  .pagination{
    margin-top: 60px !important;
    margin-bottom: -8px !important;
  }
}
  .grupo-leilao {
      background: #fcf8e9;
      padding: 14px 15px;
      margin: 17px 0;
      border-radius: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Categoria.vue